import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch, useSelector } from "react-redux";
import * as url from "../../api/uri_helper"
import Loader from "../loader";
import axios from 'axios';
import Table, { Icon, Button } from "antd/lib/table";
import { useHistory } from "react-router-dom";
import Layout from '../Layout';
import updateIcon from "../../assets/images/updateIcon.svg"
import "antd/dist/antd.css";
import '../../../src/custom.css'
import { Select, Modal } from 'antd';
import { fetchSiteDetails, fetchAllQrCodesWithThumbnail } from '../../Redux/Api/fetch.api';
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { updateInstLocationData } from '../../Redux/Actions/LocationActions';
import { Tooltip } from 'antd';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getQrCodeThumbnail } from '../../Redux/Actions/QR';
import LoginImage from "../../assets/images/login-image.png";
import { useTranslation } from "react-i18next";

const TOAST_LIMIT = 1;

const ParentChildSite = () => {
    const { t } = useTranslation("dashboard");
    const { toasts } = useToasterStore();
    useEffect(() => {
        toasts
            .filter((t) => t.visible) // Only consider visible toasts
            .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit
            .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) removal without animation
    }, [toasts]);
    const [selectedQR, setSelectedQR] = useState(null);
    const [filteredSiteOptions, setFilteredSiteOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    const [tableChild, setTableChild] = useState();
    const [total, setTotal] = useState()
    const [pageSize, setPageSize] = useState(50);
    const [qRcodeId, setQRCodeId] = useState("");
    const [qRcodeError, setQRCodeError] = useState(false);
    const [count, setCount] = useState(0);
    const [checkedListOfIds, setCheckedListOfIds] = useState([]);
    const [isMultiple, setIsMultiple] = useState(true);
    const [searchState, setSearchState] = useState()
    const [options, setOptions] = useState({
        pagination: { current: 1 },
        pageSize: 50
    });
    const [selectedChild, setSelectedChild] = useState([])
    const [pageData, setPageData] = useState({});
    const [siteData, setSiteData] = useState([]);
    const [bulkLocationId, setBulkLocationId] = useState()
    const dispatch = useDispatch();
    const [showqrdropdown, setShowQRDropdown] = useState(false);
    const [primaryqr, setPrimaryQR] = useState("");
    const loggedUserId = localStorage.getItem('UserId')

    useEffect(() => {
        getParentChildData(options, true);
        getAllSites();
        getAllQRWithThumbnail();
    }, [])

    const getParentChildData = async (options, isReset = false) => {

        setLoading(true)
        const response = await axios.post(url.GET_PARENTCHILDLOCATIONDETAIL, {
            QRcodeId: isReset ? 0 : qRcodeId,
            PageIndex: isReset ? 1 : (options.pagination ? options.pagination.current : '1'),
            PageSize: isReset ? 50 : (options.pagination.pageSize !== undefined ? options.pagination.pageSize : options.pageSize),

        }).then(response => {

            setTable(response.data.data)
            setTableChild(response.data.data)
            setTotal(response.data.data.length > 0 ? response.data.data[0].totalCount : 0);
            setOptions({
                ...options,
                pagination: {
                    current: options.pagination ? options.pagination.current : 1,
                    pageSize: options.pagination.pageSize || pageSize,
                    total: response.data.data.length > 0 ? response.data.data[0].totalCount : 0,
                    pageSizeOptions: ['50', '100'],
                    showSizeChanger: true,
                }
            });

            setShowQRDropdown(false)
            setLoading(false)
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
    };

    const getAllQRWithThumbnail = () => {

        fetchAllQrCodesWithThumbnail()
            .then(response => {
                dispatch(getQrCodeThumbnail(response.data));

            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const allQrDataWithThumbnail = useSelector((state) => state.allQrDataWithThumbnail.qrCodeThumbnailData);

    const getAllSites = () => {
        setLoading(true)
        fetchSiteDetails()
            .then(response => {
                if (response.data.success) {
                    setSiteData(response.data.data)
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const uncheckcheckbox = () => {
        var items = document.getElementsByName('checkname');
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == 'checkbox')
                items[i].checked = false;
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            getParentChildData(options, false)
        }
    }

    const columns = [

        {
            title: t("ParentQRTitle"),
            dataIndex: "qRcodeId",
            key: "i"
        },

        {
            title: t("ProductName"),
            dataIndex: "product_Name",
            className: "Products",
            render: (product_Name) => <Tooltip title={product_Name}>{product_Name}</Tooltip>,

        },

        {
            title: t("SiteName"),
            dataIndex: "siteName",
        },

        {
            title: t("CompanyName"),
            dataIndex: "companyName",
        },

        {
            title: t("AddChildQRTitle"),
            key: 'index',
            className: "update_mapping",
            render: (text, record, index) => (
                <button
                    className={`assign-btn btn ${selectedQR === record.qRcodeId ? "highlighted-icon" : ""}`}
                    id={index + 1}
                    onClick={() => {
                        handleLink(record.qRcodeId);
                    }}
                >
                    <AddCircleIcon />
                </button>
            )
        }


    ]

    const { confirm } = Modal;
    const handleLink = (primaryqr) => {
        confirm({
            title: t("AddChildQRConfirm"),
            okText: t("Yes"),
            okType: 'danger',
            cancelText: t("No"),
            onOk() {
                setSelectedQR(primaryqr);
                setShowQRDropdown(true);
                setPrimaryQR(primaryqr);
                setCheckedListOfIds([])
                uncheckcheckbox()
            },
            onCancel() {
            },
        });
    }


    const handleCheck = (qRcodeId) => {
        var updatedList = [...checkedListOfIds];
        if (event.target.checked) {
            updatedList = [...checkedListOfIds, qRcodeId];
        } else {
            updatedList.splice(checkedListOfIds.indexOf(qRcodeId), 1);
        }
        setCheckedListOfIds([...updatedList]);
        setShowQRDropdown(false)
        setSelectedQR(null)

    };


    const handleResetButton = async () => {
        setQRCodeError("")
        setQRCodeId("")
        getParentChildData(options, true)
        setShowQRDropdown(false)
        setSelectedQR(null)
    }

    const handleBulkLocationUpdate = async () => {
        debugger;
        setLoading(true)
        if (checkedListOfIds.length === 0) return;
        if (checkedListOfIds.length >= 1) {
            const data = [];
            checkedListOfIds.map(x => data.push({
                QRcodeId: x,
                LocationId: bulkLocationId
            }))
            const response = await axios.put(url.UPDATE_INSTLOCATION,
                {
                    "InstLocationQrs": data
                }).then(response => {
                    debugger;
                    dispatch(updateInstLocationData(response.data))
                    setBulkLocationId();
                    if (!response.data.success) // False 
                    {
                        debugger;
                        toast.error(response.data.message, {
                            className: "toastSuccess",
                        });
                    }
                    else {
                        toast.success(response.data.message, {
                            className: "toastSuccess",
                        })
                    }
                    setLoading(false)
                })
            setQRCodeId()
            getParentChildData(options, true)
            setCheckedListOfIds('')
            uncheckcheckbox();

        }
    };

    const AddChildQRCodes = async () => {

        setLoading(true)
        const data = [];
        console.log('data :', selectedChild);
        selectedChild.map(x => data.push({
            ChildQRcode: x,
            Id: x.id,
            ParentQR: primaryqr
        }))
        const response = await axios.put(url.ADD_BULKCHILDQRS,
            {
                "BulkChildQrs": data,
                "UserId": loggedUserId
            }).then(response => {

                dispatch(updateInstLocationData(response.data))

                if (!response.data.success) // False 
                {

                    toast.error(response.data.message, {
                        className: "toastSuccess",
                    });
                }
                else {
                    toast.success(response.data.message, {
                        className: "toastSuccess",
                    })
                }
                setLoading(false)
            })

        setSelectedChild([])
        getParentChildData(options, true)
        setSelectedQR(null)

    }

    const handleInputForSiteDropdown = (input) => {

        const filtered = siteData && siteData.filter(item => {
            const fullName = item.siteName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredSiteOptions(filtered);
    };


    const expandedRowRender = (index) => {
        const nestedcolumns = [

            {
                title: " ",
                dataIndex: "qRcodeId",
                hidden: false,
                render: (qRcodeId) => (<div className="checkgroup">
                    {
                        <input type="checkbox" className="btn-checkbox" name="checkname"

                            onChange={() => { handleCheck(qRcodeId) }}
                            key={qRcodeId}
                        ></input>
                    }
                </div>)
            },

            {
                title: t("ChildQRTitle"),
                dataIndex: "qRcodeId",
                key: "i"
            },

            {
                title: t("ProductName"),
                dataIndex: "product_Name",
                className: "Products",
                render: (product_Name) => <Tooltip title={product_Name}>{product_Name}</Tooltip>,

            },

            {
                title: t("SiteName"),
                dataIndex: "siteName",
            },

            {
                title: t("CompanyName"),
                dataIndex: "companyName",
            },


        ]
        return <Table className="nested-table" columns={nestedcolumns} dataSource={
            tableChild[index].childQRsList
        } pagination={false} />
    };

    const handleInputForDropdown = (e) => {
        const QRProductPresent = allQrDataWithThumbnail.filter((item) => item.qRcodeId.toString().startsWith(e) || item.qRcodeId.toString().includes(e))
        QRProductPresent.length > 0 ? setSearchState("Number") : setSearchState("String")
    }

    const handleOnChange = (e) => {
        setSelectedChild(e)
    };

    const handleChange = (pagination, sorter) => {
        const shouldResetPageIndex = pagination.pageSize !== options.pagination.pageSize;

        const updatedPagination = {
            ...pagination,
            current: shouldResetPageIndex ? 1 : pagination.current
        };

        const updatedOptions = {
            ...options,
            pagination: updatedPagination
        };

        setOptions(updatedOptions);
        setPageData(updatedOptions);

        getParentChildData(updatedOptions);
    };

    return (
        <Layout title={t("ParentChildQRReview")}>
            <Toaster />
            <>

                <div className="position-relative">

                    <div className="card-box-header qrassign-header d-flex w-100 flex-wrap align-items-center m-0 gap-3 justify-content-between">
                        <div className="flex-wrap  d-flex gap-2 filter-box1 ">
                            <span className="">{t("SearchByQR")}</span>
                            <div className="d-flex flex-wrap gap-3 width-box">
                                <div className="d-flex flex-column position-relative">
                                    <input type="text" className='form-control searchQR w-100 m-0' value={qRcodeId} placeholder={t("EnterQR")}
                                        // onKeyPress={(e) => {
                                        //     if (new RegExp(/^[0-9\b]+$/).test(e.key)) {
                                        //     } else e.preventDefault();
                                        // }}
                                        inputMode='numeric'
                                        onKeyDown={(e) => handleKeyPress(e)}
                                        onChange={(e) => {
                                            const onlyDigits = e.target.value.replace(/\D/g, "");
                                            setQRCodeId(onlyDigits);
                                            setCount(onlyDigits.length);
                                            if (onlyDigits.startsWith('0')) { setQRCodeError(t("EnterValidQR")) }
                                            else { setQRCodeError("") }
                                        }}
                                    >
                                    </input>
                                    {qRcodeError != "" ?
                                        <small className='text-danger d-block qRcodeError top-100 position-absolute position-md-absolute position-sm-relative' >{qRcodeError}</small> : ""
                                    }
                                </div>
                                <button className="searchButton"
                                    onClick={() => {
                                        if (qRcodeId.trim() === "") { setQRCodeError(t("PleaseEnterQRCode")) }
                                        else if (count < 2 && qRcodeId != "") { setQRCodeError(t("EnterValidQRCodeError")) }
                                        else { setQRCodeError("") }
                                        if (count > 2) {
                                            getParentChildData(options, false)
                                        }
                                    }}
                                // disabled={!qRcodeId}


                                >{t("Search")}</button>
                                {qRcodeId == "" ? "" : <button className='searchButton' onClick={() =>
                                    handleResetButton()}
                                >{t("Reset")}</button>}
                            </div>

                        </div>
                        {checkedListOfIds.length >= 1 ?
                            <div className="update_location flex-wrap  d-flex gap-2 filter-box1" >
                                {checkedListOfIds.length >= 1 ?
                                    <span className="">{t("UpdateSiteLabel")}</span> : ""
                                }
                                <div className="d-flex gap-2 width-box flex-wrap">
                                    {checkedListOfIds.length >= 1 ?
                                        <Select class="form-select mb-0 flex-grow-1 filter-select " aria-label=".form-select-lg example"
                                            showSearch
                                            style={{ width: "200px" }}
                                            className='custom-select-ss'
                                            placeholder={t("UpdateSitePlaceholder")}
                                            value={bulkLocationId}
                                            onSearch={(value) => {
                                                handleInputForSiteDropdown(value)
                                            }}
                                            filterOption={false}
                                            onChange={(e) => {
                                                setBulkLocationId(e)
                                            }}
                                        >
                                            {filteredSiteOptions.length > 0 ?
                                                filteredSiteOptions && filteredSiteOptions.map(item =>
                                                    <Option key={item.siteId} value={item.siteId}>
                                                        {item.siteName}
                                                    </Option>
                                                )
                                                :
                                                siteData && siteData.map(item =>
                                                    <Option key={item.siteId} value={item.siteId}>
                                                        {item.siteName}
                                                    </Option>
                                                )
                                            }

                                        </Select>
                                        : ""
                                    }
                                    {checkedListOfIds.length >= 1 && bulkLocationId ?
                                        <button className="searchButton" onClick={() => handleBulkLocationUpdate()}>{t("BulkSiteUpdate")}</button> :
                                        ""
                                    }
                                </div>



                            </div> : ""
                        }

                        {showqrdropdown ?

                            <div class="d-flex gap-4 ml-auto align-items-center flex-wrap">

                                <div className="primary-qr-text">
                                    <b>{t("ParentQR")}:</b> {primaryqr}
                                </div>
                                <div className="filter-box-1 d-flex gap-2 align-items-center flex-md-nowrap">
                                    <span className="text-nowrap">{t("SelectChildQR")} </span>
                                    <div class="d-flex select-qr-select gap-2 flex-wrap w-100">
                                        <Select
                                            class="form-select mb-0 flex-grow-1 filter-select"
                                            aria-label=".form-select-lg example"
                                            showSearch
                                            value={selectedChild}
                                            optionFilterProp="label" // search works on label
                                            optionLabelProp="label" // show label in selected box
                                            onChange={handleOnChange}
                                            onSearch={(e) => {
                                                handleInputForDropdown(e)
                                            }}
                                            dropdownAlign={{ points: ['tr', 'br'], offset: [0, 4] }}
                                            dropdownStyle={{ minWidth: 300 }}
                                            mode={`${isMultiple && 'multiple'}`}
                                        >
                                            <Option value="0">{t("SelectQRPlaceholder")} </Option>
                                            {allQrDataWithThumbnail &&
                                                allQrDataWithThumbnail
                                                    .filter(QRCode => QRCode.qRcodeId !== primaryqr)
                                                    .map((QRCode, k) =>

                                                        <Option
                                                            key={QRCode.qRcodeId}
                                                            value={QRCode.qRcodeId}
                                                            label={`${QRCode.qRcodeId}`}
                                                        >
                                                            <div className="d-flex gap20 align-items-center">
                                                                <div className="avatar-img">
                                                                    {QRCode.filename ?
                                                                        <>
                                                                            < img className="img-mapping" src={QRCode.filename}></img>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            < img className="img-mapping" src={LoginImage}></img>
                                                                        </>}
                                                                </div>
                                                                <div className="qrDesc content d-flex">
                                                                    {QRCode.product_Name ? <Tooltip title={QRCode.product_Name}>
                                                                        <h6>{QRCode.product_Name}</h6>
                                                                    </Tooltip>
                                                                        : <h6>- NA - </h6>}
                                                                    <p>{QRCode.qRcodeId}</p>
                                                                    <Tooltip title={QRCode.qR_Description}>
                                                                        <p>{QRCode.qR_Description}</p>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </Option>

                                                    )}
                                        </Select>

                                        {showqrdropdown && selectedChild.length > 0 ?
                                            <button className="searchButton"
                                                onClick={() => {
                                                    // setShowQRDropdown(false);
                                                    AddChildQRCodes()
                                                }}
                                            >
                                                {t("Save")} </button> :
                                            ""
                                        }
                                    </div>
                                </div>
                            </div>

                            : ""
                        }
                    </div>
                </div>


                <div className="table-responsive Viewer-table position-relative mb-4 device-type pagination-sticky data-table">
                    {loading ? <Loader /> : ''}
                    <Table
                        className='table-responsive antd--detail-table1 Viewer-table'
                        columns={columns}
                        dataSource={table}
                        expandedRowRender={(_, index) => expandedRowRender(index)}
                        pagination={
                            total > 50 ? options.pagination : false
                        }
                        onChange={handleChange}


                        scroll={{ x: "750px" }}
                    ></Table>
                </div>
            </>
        </Layout>
    )
}

export default connect()(ParentChildSite);